<template>
  <el-dialog :visible.sync="visible" :title="(!dataForm.id ? $t('add') : $t('update'))+'分组'" :close-on-click-modal="false" :close-on-press-escape="false"  :append-to-body="true">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
          <el-form-item label="分组名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="分组名称"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      id:'',
      visible: false,
      dataForm: {
      id: '',
      name: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]      }
    }
  },
  methods: {
    reset(){
      this.dataForm={
                                    name: ''                    }
      if(this.$refs['dataForm']){
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/table/${this.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm={
          ...this.dataForm
        }
        this.$http[!postForm.id ? 'post' : 'put']('/sys/table/group', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel(){
      this.visible = false
    }
  }
}
</script>
